'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (article, _partners, otherFtMap) {
  if (!article) {
    return;
  }
  var partners = _partners;
  partners = _lodash2.default.castArray(partners).filter(Boolean);
  //  为了小说js文件加载 不依赖单一的subjectId 条件判断而拓展的配置文件，只依赖window下面的字段配置来读取要加载的js
  if (!partners.length && _lodash2.default.isEmpty(otherFtMap)) {
    return;
  }

  var result = {};
  var externalScript = [];
  partners.forEach(function (_ref) {
    var condition = _ref.condition,
        settings = _ref.settings;

    if (!condition) {
      return;
    }
    _lodash2.default.mapValues(condition, function (value, key) {
      var target = _lodash2.default.get(article, key);
      if (!target) {
        // 灰度策略中支持屏蔽外接其他FT的js 以extraInfo中的key为条件
        return;
      }
      var matched = !!_lodash2.default.intersection(_lodash2.default.castArray(value), _lodash2.default.castArray(target).map(String)).length;
      if (matched) {
        if (settings.externalScript && externalScript.indexOf(settings.externalScript) < 0) {
          externalScript.push(settings.externalScript);
        }
        Object.assign(result, settings);
      }
    });
  });
  result.externalScript = externalScript;
  // externalScript 特殊处理
  if (!result.externalScript) {
    var tags = article.tags;

    var tagList = _lodash2.default.uniq((tags || []).filter(function (_ref2) {
      var eTagType = _ref2.eTagType;
      return eTagType === 0 || eTagType === 2;
    } // 优质tag
    ).map(function (_ref3) {
      var lTagId = _ref3.lTagId;
      return lTagId;
    })).map(String);

    if (tagList.length) {
      partners.some(function (_ref4) {
        var tagId = _ref4.tagId,
            script = _ref4.script;

        if (tagId && _lodash2.default.intersection(_lodash2.default.castArray(tagId), tagList).length) {
          Object.assign(result, {
            externalScript: [script]
          });
          return true; // break;
        }
        return false;
      });
    }
  }
  return result;
}; /* 根据正文配置信息获取其他ft的脚本文件或者配置的方法 */